import {BaseCard} from "../../Components/Cards/BaseCard";
import Logo from "../../Assets/images/logo/connectcaremintgreen.png";
import {IconInputCard} from "../../Components/Cards/IconInputCard";
import {
    faBuilding,
    faCalendar,
    faCertificate,
    faEnvelope, faFloppyDisk,
    faMapPin,
    faPencil,
    faPhone, faTimes,
    faUser
} from "@fortawesome/free-solid-svg-icons";
import {BlackButton} from "../../Components/Buttons/BlackButton";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {LanguageSelector} from "../../Components/Form/LanguageSelector";
import {useBoundStore} from "../../Store/store";
import {useEffect, useState} from "react";
import * as yup from "yup";
import {useForm} from "react-hook-form";
import {yupResolver} from "@hookform/resolvers/yup";
import toast from "react-hot-toast";
import {SecondaryButton} from "../../Components/Buttons/SecondaryButton";
import {TextInput} from "../../Components/Form/TextInput";
import {SelectInput} from "../../Components/Form/SelectInput";
import * as React from "react";
import {NumberInput} from "../../Components/Form/NumberInput";
import {useTranslation} from "react-i18next";

export const MyProfile = () => {
    const {t} = useTranslation();
    const [isEditing, setIsEditing] = useState(false);

    const updateMe = useBoundStore(state => state.updateMe);
    const updateMyLocale = useBoundStore(state => state.updateMyLocale);
    const getMe = useBoundStore(state => state.getMe);
    const user = useBoundStore(state => state.user);


    const jobFunctions = [
        {value: 'A1', label: t('functions.A1'), id: 0},
        {value: 'A2', label: t('functions.A2'), id: 1},
        {value: 'A0', label: t('functions.A0'), id: 2},
        {value: 'A3', label: t('functions.A3'), id: 3}
    ]

    useEffect(() => {
        getMe();
    },[getMe]);

    const schema = yup.object({
        firstname: yup.string().required(),
        lastname: yup.string().required(),

        street: yup.string().required(),
        tel: yup.string().required(),
        house_number: yup.string().required(),
        bus: yup.string().nullable(),
        city: yup.string().required(),
        zip: yup.string().required(),

        function: yup.string().required(),
        experience_from_year: yup.number().required().min(0).max(70),

        vat_number: yup.string().required(),
        company_name: yup.string().required(),
        bank_account: yup.string().required(),
    }).required()

    const {
        register,
        handleSubmit,
        formState: {errors},
        reset,
        control,
        setValue,
    } = useForm({
        resolver: yupResolver(schema),
        reValidateMode: 'onBlur',
        mode: 'onChange',
        defaultValues: {
            firstname: user?.firstname,
            lastname: user?.lastname,
            function: user?.function,
            experience_from_year: user?.experience_from_year,

            street: user?.branches?.[0]?.street,
            tel: user?.branches?.[0]?.contact_tel,
            house_number: user?.branches?.[0]?.number,
            bus: user?.branches?.[0]?.bus,
            city: user?.branches?.[0]?.city,
            zip: user?.branches?.[0]?.postal,

            vat_number: user?.branches?.[0]?.vat_number,
            company_name: user?.branches?.[0]?.company_name,
            bank_account: user?.branches?.[0]?.bank_account,
        }
    });

    useEffect(() => {
        if(user !== null){
            reset({
                firstname: user?.firstname,
                lastname: user?.lastname,

                street: user?.branches?.[0]?.street,
                tel: user?.branches?.[0]?.contact_tel,
                house_number: user?.branches?.[0]?.number,
                bus: user?.branches?.[0]?.bus,
                city: user?.branches?.[0]?.city,
                zip: user?.branches?.[0]?.postal,

                function: user?.function,
                experience_from_year: user?.experience_from_year,

                vat_number: user?.branches?.[0]?.vat_number,
                company_name: user?.branches?.[0]?.company_name,
                bank_account: user?.branches?.[0]?.bank_account,
            })
        }
    }, [user, isEditing]);

    const onSubmit = (data) => {
        updateMe(data);
        setIsEditing(!isEditing);
        toast.success(t('profile.toast_saved'))
    }

    return (
        <div>
            <div className={"rounded-lg mb-6 relative flex flex-row justify-between p-6"}>
                <div className={'opacity-40 rounded-lg bg-gradient-to-b from-primary to-secondary absolute top-0 left-0 w-full h-full'}></div>
                <div className={'z-10 my-auto'}>
                    <div className={"font-bold text-2xl p-2 flex flex-row"}>
                        <div className={'rounded-full w-12 h-12 p-2 bg-primary bg-opacity-60 mr-2 flex flex-col justify-center'}>
                            <span className={'m-auto text-md'}>👋</span>
                        </div>
                        <span className={'my-auto text-4xl'}>{t('profile.greeting', {name: user.firstname})}</span>
                    </div>
                    <p>
                        {t('profile.welcome_message')}
                    </p>
                </div>

                <div className={'ml-4 z-10 max-h-52 hidden md:flex'}>
                    <img src={Logo} alt="logo" className={'w-full h-full object-contain'}/>
                </div>
            </div>

            <BaseCard>
                <form className={'grid grid-cols-1'} onSubmit={handleSubmit(onSubmit)}>
                    <div className={'grid grid-cols-1 md:grid-cols-2'}>
                        <h1 className={'text-xl font-bold mb-4'}>{t('profile.title')}</h1>
                        <div className={'flex flex-row justify-end'}>
                            {
                                !isEditing && (
                                    <BlackButton text={'secondary'} onClick={() => setIsEditing(!isEditing)}>
                                        <FontAwesomeIcon icon={faPencil} className={'mr-2'}/> {t('general.actions.adjust')}
                                    </BlackButton>
                                )
                            }

                            {
                                isEditing && (
                                    <div className={'grid grid-cols-2 gap-4'}>
                                        <SecondaryButton text={'secondary'} onClick={() => setIsEditing(!isEditing)}>
                                            <FontAwesomeIcon icon={faTimes} className={'mr-2'}/> {t('general.actions.cancel')}
                                        </SecondaryButton>
                                        <BlackButton outlined={true} type={'submit'}>
                                            <FontAwesomeIcon icon={faFloppyDisk} className={'mr-2'}/> {t('general.actions.save')}
                                        </BlackButton>
                                    </div>

                                )
                            }
                        </div>
                    </div>

                    <h2 className={'text-gray-500 text-sm'}>{t('profile.personal_info')}</h2>
                    <div className={'grid grid-cols-1 md:grid-cols-2 gap-4 mt-2'}>
                        <IconInputCard
                            icon={faUser}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.firstname')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'Firstname'}
                                        name={'firstname'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.firstname}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faUser}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.lastname')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'Lastname'}
                                        name={'lastname'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.lastname}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faEnvelope}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.email')}</p>
                            <p className={'text-xs'}>{user.email}</p>
                        </IconInputCard>

                        <IconInputCard
                            icon={faPhone}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.tel')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'Phone'}
                                        name={'tel'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.branches?.[0]?.contact_tel}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faCalendar}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.experience')}</p>
                            {
                                isEditing ? (
                                    <NumberInput
                                        name={'experience_from_year'}
                                        register={register}
                                        translationIndex={'general.fields.experience'}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user.experience_from_year}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faBuilding}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.function')}</p>
                            {
                                isEditing ? (
                                    <SelectInput
                                        label={'Function'}
                                        name={'function'}
                                        register={register}
                                        control={control}
                                        setValue={setValue}
                                        translationIndex={'general.fields.function'}
                                        options={jobFunctions}
                                        errors={errors}
                                    />
                                ) : (
                    <p className={'text-xs'}>{jobFunctions.find(jf => jf.value === user.function)?.label ?? '-'}</p>
                                )
                            }
                        </IconInputCard>
                    </div>

                    <hr className="mt-6 mb-6 border-gray-200"/>

                    <h2 className={'text-gray-500 text-sm'}>{t('freelancers_module.statuten_heading')}</h2>
                    <div className={'flex flex-wrap gap-2 mt-2'}>
                        {(() => {
                            const main = user?.main_statuut ?? 'freelance';
                            const extras = user?.extra_statuten ?? [];
                            return (
                                <>
                                    <span className="text-xs bg-primary text-white px-2 py-1 rounded">
                                        {t('freelancers_module.main_statuut_prefix')} {t(`statuten.${main}`, main)}
                                    </span>
                                    {extras.length > 0
                                        ? extras.map(s => (
                                            <span key={s} className="text-xs bg-purple-100 text-purple-800 px-2 py-1 rounded">
                                                + {t(`statuten.${s}`, s)}
                                            </span>
                                        ))
                                        : <span className="text-xs text-gray-500">{t('freelancers_module.no_extra_statuten')}</span>
                                    }
                                </>
                            );
                        })()}
                    </div>

                    <hr className="mt-6 mb-6 border-gray-200"/>

                    {/* CCPSOM-30: language selector disabled until multi-language support is ready
                    <h2 className={'text-gray-500 text-sm'}>{t('language.label')}</h2>
                    <div className="mt-2 max-w-xs">
                        <LanguageSelector
                            value={user?.locale ?? 'nl'}
                            onChange={(loc) => updateMyLocale(loc)}
                        />
                    </div>

                    <hr className="mt-6 mb-6 border-gray-200"/> */}

                    <h2 className={'text-gray-500 text-sm'}>{t('general.labels.address')}</h2>
                    <div className={'grid grid-cols-1 md:grid-cols-2 gap-4 mt-2'}>

                        <IconInputCard
                            icon={faMapPin}
                            className={'col-span-2'}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.street')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'street'}
                                        name={'street'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.branches?.[0]?.street}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faMapPin}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.city')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'city'}
                                        name={'city'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.branches?.[0]?.city}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faMapPin}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.nr')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'house_number'}
                                        name={'house_number'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.branches?.[0]?.number}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faMapPin}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.bus')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'bus'}
                                        name={'bus'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.branches?.[0]?.bus}</p>
                                )
                            }
                        </IconInputCard>

                        <IconInputCard
                            icon={faMapPin}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.postal_code')}</p>
                            {
                                isEditing ? (
                                    <TextInput
                                        label={'zip'}
                                        name={'zip'}
                                        register={register}
                                        errors={errors}
                                    />
                                ) : (
                                    <p className={'text-xs'}>{user?.branches?.[0]?.postal}</p>
                                )
                            }
                        </IconInputCard>
                    </div>

                    <hr className="mt-6 mb-6 border-gray-200"/>

                    <h2 className={'text-gray-500 text-sm'}>{t('general.labels.company_information')}</h2>
                    <div className={'grid grid-cols-1 md:grid-cols-2 gap-4 mt-2'}>
                        <input type="hidden" {...register('vat_number')} />
                        <input type="hidden" {...register('company_name')} />
                        <input type="hidden" {...register('bank_account')} />

                        <IconInputCard
                            icon={faBuilding}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.company_name')}</p>
                            <p className={'text-xs'}>{user?.branches?.[0]?.company_name}</p>
                        </IconInputCard>

                        <IconInputCard
                            icon={faCertificate}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.vat_number')}</p>
                            <p className={'text-xs'}>{user?.branches?.[0]?.vat_number}</p>
                        </IconInputCard>

                        <IconInputCard
                            icon={faCertificate}
                        >
                            <p className={'text-xs text-gray-500'}>{t('general.fields.bank_account')}</p>
                            <p className={'text-xs'}>{user?.branches?.[0]?.bank_account}</p>
                        </IconInputCard>
                    </div>
                </form>

            </BaseCard>
        </div>
    )
}